import React, { Component } from 'react';
// import { Router, Route, IndexRoute } from 'react-router';
import { HashRouter, Switch, Route, BrowserRouter} from 'react-router-dom';
import Gas from '../views/Gas/Gas';
import Credit from '../views/Credit/Credit';
import CreditView from '../views/Credit/CreditView';
import Facility from '../views/Facility/Facility';
import FacilityView from '../views/Facility/FacilityView';
import Booking from '../views/Facility/Booking';
import BookingList from '../views/Facility/BookingList';
import Repair from '../views/Repair/Repair';
import EBook from '../views/EBook/EBook';
import UserProfile from '../views/UserProfile/UserProfile';
import AuthPhone from '../views/UserProfile/AuthPhone';
import CasePeriod from '../views/CasePeriod/CasePeriod';
import PaymentPeriod from '../views/PaymentPeriod/PaymentPeriod';
import Drawing from '../views/Drawing/Drawing';
import Sent from '../views/Drawing/Sent';
import Contacts from '../views/Contacts/Contacts';
import Blank from '../views/Blank/Blank';

import ForgotAccount from '../views/Forgot/ForgotAccount';
import Payment from '../views/Payment/Payment';
import qs from "query-string";
import http from '../helpers/http';

class App extends Component 
{
  constructor(props)
  {
    super(props);

    let pathArray = window.location.hash.split( '?' );
    if (pathArray.length > 1)
    {
      let queryString = pathArray[1]

      const parsed = qs.parse(queryString);
      
      parsed["Access-Token"] && http.setToken(parsed["Access-Token"])
    }
  }

  componentWillReceiveProps(nextProps)
  {
    
  }
  componentWillUnmount()
  {
    
  }
  
  render() 
  {
    
    var pathArray = window.location.pathname.split( '/' );
    
    const path = window.location.pathname.replace(pathArray[pathArray.length -1], '')
    // <Switch basename={ path }>
    return (
      <div>
        <BrowserRouter>
          <Switch>
            <Route path="/blank"                  component={ Blank }/>
          </Switch>
        </BrowserRouter>
        <HashRouter >
          <Switch basename={ path }>
            <Route path="/gas"                  component={ Gas }/>
            <Route path="/credit"               component={ Credit }/>
            <Route path="/creditview"           component={ CreditView }/>
            <Route path="/point/list"           component={ Credit }/>
            <Route path="/point/detail"         component={ CreditView }/>
            <Route path="/facility"             component={ Facility }/>
            <Route path="/facilityview"         component={ FacilityView }/>
            <Route exact path="/booking"        component={ Booking }/>
            <Route exact path="/bookinglist"    component={ BookingList }/>
            <Route exact path="/repair"         component={ Repair }/>
            <Route exact path="/repair/:qa_id"  component={ Repair }/>
            <Route path="/forgot/account"       component={ ForgotAccount }/>
            <Route exact path="/payment"        component={ Payment }/>
            <Route path="/ebook/interduce"      component={ EBook }/>
            <Route path="/ebook"                component={ EBook }/>
            
            {/* PHASE3 BEGIN */}
            <Route exact path="/user/profile"      component={ UserProfile } />
            <Route exact path="/user/profile/auth" component={ AuthPhone } />
            <Route path="/case/period"             component={ CasePeriod }/>
            <Route path="/payment/period"          component={ PaymentPeriod }/>
            <Route exact path="/drawing"           component={ Drawing }/>
            <Route path="/drawing/sent"            component={ Sent }/>
            <Route path="/drawing/sent/:drawing_ids" component={ Sent }/>
            <Route path="/contacts"                component={ Contacts }/>
            <Route path="/blank"                component={ Blank }/>
            {/* PHASE3 END */}
            
          </Switch>
        </HashRouter>
      </div>
    );
  }
}

export default App;


// WEBPACK FOOTER //
// ./src/routes/App.js